import { Link } from 'react-router-dom';

export default function ServicesHero() {
  return (
    <section className="relative pt-24 min-h-[520px] flex items-center bg-slate-900 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/460bf14f2df003478a0a95ef187965c0.jpg"
          alt="City to City Moving Services — professional movers loading truck in Southern California"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-slate-900/50"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 w-full">
        <div className="flex items-center gap-2 text-orange-400 text-sm font-semibold mb-5">
          <Link to="/" className="hover:text-orange-300 transition-colors">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">Services</span>
        </div>
        <div className="max-w-2xl">
          <span className="inline-block bg-orange-500/20 text-orange-300 text-xs font-bold px-4 py-2 rounded-full mb-5 border border-orange-500/30">
            Licensed &amp; Insured · 20+ Years Experience
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-5">
            Professional Moving Services in{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-red-400">
              Southern California
            </span>
          </h1>
          <p className="text-slate-300 text-lg leading-relaxed mb-8">
            From local apartment moves to cross-country relocations and specialty item handling, City to City Moving Company offers every moving service you need — backed by expert crews, transparent pricing, and a commitment to stress-free moves.
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="tel:7606257767"
              className="flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-7 py-3.5 rounded-xl font-bold hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap">
              <i className="ri-phone-fill text-lg"></i>Call for a Free Quote
            </a>
            <a href="/#quote-form"
              className="flex items-center gap-2 bg-white/10 border border-white/20 text-white px-7 py-3.5 rounded-xl font-semibold hover:bg-white/20 transition-all whitespace-nowrap">
              <i className="ri-file-list-3-line text-lg"></i>Request Estimate Online
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
